import changeCities from "../modules/Utils/changeCities";
import productFilter from "../modules/Utils/product_ordering";


productFilter();
changeCities();